<template>
  <v-container
    fluid
    v-touch="{
      right: () => swipe(),
    }"
    height="100vh"
  >
    <input
      type="file"
      ref="fileInput"
      style="display: none"
      @change="handleFileChange"
      multiple
    />
    <div class="d-flex flex-column justify-space-between" style="height: 100%">
      <div>
        <v-row class="actions align-center" justify="space-between">
          <v-col class="back-arrow" cols="auto">
            <v-btn
              variant="text"
              class="ma-0"
              density="compact"
              icon="mdi-chevron-left"
              :disabled="loading"
              @click="this.$emit('update:modal', false)"
            >
            </v-btn>
          </v-col>
          <v-col cols="auto" v-if="$store.state.isMobile">
            <v-btn
              variant="text"
              icon
              color="#2CA6F7"
              @click="openFileDialog"
              :disabled="loading"
            >
              <v-icon>
                <svg
                  width="21"
                  height="23"
                  viewBox="0 0 21 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.582 5.69286L6.692 13.2459C6.46775 13.4565 6.28903 13.7109 6.16687 13.9933C6.0447 14.2757 5.98167 14.5802 5.98167 14.8879C5.98167 15.1956 6.0447 15.5 6.16687 15.7824C6.28903 16.0648 6.46775 16.3192 6.692 16.5299C7.15625 16.9666 7.76962 17.2097 8.407 17.2097C9.04438 17.2097 9.65775 16.9666 10.122 16.5299L17.956 9.03186C18.3822 8.63161 18.7219 8.14827 18.9541 7.61166C19.1864 7.07506 19.3062 6.49656 19.3062 5.91186C19.3062 5.32716 19.1864 4.74867 18.9541 4.21206C18.7219 3.67545 18.3822 3.19211 17.956 2.79186C16.156 1.06886 13.238 1.06886 11.438 2.79186L3.489 10.3999C0.837 12.9399 0.837 17.0559 3.489 19.5959C6.141 22.1359 10.443 22.1349 13.096 19.5959L19.5 13.4659"
                    stroke="#2CA6F7"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                </svg>
              </v-icon>
            </v-btn>
            <v-btn
              variant="text"
              icon
              color="#2CA6F7"
              @click="send"
              :disabled="loading"
            >
              <v-icon>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.7604 10H3.83238C3.83238 9.725 3.77538 9.45 3.66238 9.192L1.28538 3.814C0.52538 2.094 2.34338 0.371998 4.01938 1.223L17.8004 8.217C19.2604 8.957 19.2604 11.043 17.8004 11.783L4.02038 18.777C2.34338 19.628 0.52538 17.905 1.28538 16.186L3.66038 10.808C3.77263 10.5534 3.83053 10.2782 3.83038 10"
                    stroke="#232526"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="align-center ma-0 pa-0">
          <v-list-item-subtitle class="mr-4 mt-3">Кому</v-list-item-subtitle>
          <v-combobox
            v-model="mailsTo"
            variant="plain"
            multiple
            chips
            clearable
            hide-details
            :items="itemsTo"
            @update:modelValue="handleInput"
          >
            <template v-slot:selection="{ item, index }">
              <v-chip
                v-if="index < 2"
                :key="JSON.stringify(item)"
                close
                @click:close="removeChip(index, 'to')"
              >
                {{ item }}
              </v-chip>
              <span
                v-if="index === 2"
                class="text-grey text-caption align-self-center"
              >
                (+{{ chipsTo.length - 2 }} ещё)
              </span>
            </template>
          </v-combobox>
        </v-row>
        <v-row class="align-center ma-0 pa-0">
          <v-list-item-subtitle class="mr-9 mt-3">От</v-list-item-subtitle>
          <v-select
            hide-details
            v-model="from"
            variant="plain"
            chips
            :items="itemsFrom"
          >
          </v-select>
        </v-row>
        <v-row class="align-center mb-4 ma-0 pa-0">
          <v-list-item-subtitle class="mr-4 mt-4">Тема</v-list-item-subtitle>
          <v-text-field
            hide-details
            v-model="theme"
            variant="plain"
          ></v-text-field>
        </v-row>
        <v-expansion-panels class="mb-4" rounded="xl" v-if="files.length > 0">
          <v-expansion-panel title="Прикрепленные файлы">
            <v-expansion-panel-text>
              <v-row class="files mb-2 d-flex flex-column">
                <v-list
                  :class="$store.state.isMobile ? '' : 'd-flex flex-wrap'"
                >
                  <v-list-item
                    rounded="xl"
                    v-for="(file, index) in files"
                    :key="file"
                    @click="fileDownload(file)"
                  >
                    <v-icon :icon="file.icon"></v-icon>
                    {{ file.name }}
                    <template v-slot:append>
                      <v-icon
                        icon="mdi-close-circle"
                        @click="deleteFile(index)"
                      ></v-icon>
                    </template>
                  </v-list-item>
                </v-list>
              </v-row>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-row class="mb-4 ma-0 pa-0">
          <TextEditor v-model:content="content"></TextEditor>
        </v-row>
      </div>
      <div v-if="!$store.state.isMobile">
        <v-file-upload
          v-if="isUpload && !$store.state.isMobile"
          v-model="newFiles"
          density="compact"
          variant="compact"
          rounded="xl"
          multiple
          max-height="20"
          show-size
          clearable
          @change="handleFileChange"
        >
          <template v-slot:item="{ props: itemProps }">
            <v-file-upload-item v-bind="itemProps" lines="one" nav rounded="xl">
              <template v-slot:prepend>
                <v-avatar size="32" rounded></v-avatar>
              </template>

              <template v-slot:clear="{ props: clearProps }">
                <v-btn
                  color="#2CA6F7"
                  v-bind="clearProps"
                  :disabled="loading"
                ></v-btn>
              </template>
            </v-file-upload-item>
          </template>
        </v-file-upload>
        <v-row class="ma-0 pa-0 align-center">
          <v-btn color="#2CA6F7" class="mr-4" @click="send" :disabled="loading"
            >Отправить</v-btn
          >
          <v-btn
            variant="text"
            icon
            @click="isUpload = !isUpload"
            :disabled="loading"
          >
            <v-icon>
              <svg
                width="21"
                height="23"
                viewBox="0 0 21 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.582 5.69286L6.692 13.2459C6.46775 13.4565 6.28903 13.7109 6.16687 13.9933C6.0447 14.2757 5.98167 14.5802 5.98167 14.8879C5.98167 15.1956 6.0447 15.5 6.16687 15.7824C6.28903 16.0648 6.46775 16.3192 6.692 16.5299C7.15625 16.9666 7.76962 17.2097 8.407 17.2097C9.04438 17.2097 9.65775 16.9666 10.122 16.5299L17.956 9.03186C18.3822 8.63161 18.7219 8.14827 18.9541 7.61166C19.1864 7.07506 19.3062 6.49656 19.3062 5.91186C19.3062 5.32716 19.1864 4.74867 18.9541 4.21206C18.7219 3.67545 18.3822 3.19211 17.956 2.79186C16.156 1.06886 13.238 1.06886 11.438 2.79186L3.489 10.3999C0.837 12.9399 0.837 17.0559 3.489 19.5959C6.141 22.1359 10.443 22.1349 13.096 19.5959L19.5 13.4659"
                  stroke="#2CA6F7"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
              </svg>
            </v-icon>
          </v-btn>
        </v-row>
      </div>
    </div>
  </v-container>
</template>
<script>
import { VFileUpload } from "vuetify/labs/VFileUpload";
import TextEditor from "./TextEditor.vue";
import axios from "axios";

export default {
  name: "SendModal-component",
  components: {
    VFileUpload,
    TextEditor,
  },
  props: {
    item: Object,
    modelValue: Boolean,
    newMail: String,
    fwd: Boolean,
    index: Number,
  },
  emits: ["update:modal"],
  data() {
    return {
      loading: false,
      newFiles: [],
      isUpload: false,
      theme: "",
      chipsTo: [],
      items: [],
      mailsTo: [],
      itemsFrom: [],
      from: null,
      files: [],
      content: "",
    };
  },
  methods: {
    convertFileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader(); // Создаем объект FileReader

        reader.onload = () => {
          // Удаляем префикс "data:*/*;base64," из результата
          const base64 = reader.result.split(",")[1];
          resolve(base64); // Возвращаем чистый base64
        };

        reader.onerror = (error) => {
          reject(error); // Обрабатываем ошибку
        };

        reader.readAsDataURL(file); // Читаем файл как Data URL
      });
    },
    async send() {
      try {
        this.loading = true;
        let formData = new FormData();
        console.log(this.index);
        console.log(this.$store.state.mailbox[this.index]);

        formData.append(
          `params`,
          this.$store.state.mailbox[this.index].type == "imap"
            ? "sendMail"
            : "sendMailOAuth"
        );
        formData.append(`login`, this.$store.state.mailbox[this.index].title);
        formData.append(`password`, this.$store.state.mailbox[this.index].pass);
        formData.append(
          `clientId`,
          this.$store.state.settings[
            this.$store.state.mailbox[this.index].server
          ].clientId
        );
        formData.append(
          `clientSecret`,
          this.$store.state.settings[
            this.$store.state.mailbox[this.index].server
          ].client_secret
        );
        formData.append(
          `refreshToken`,
          this.$store.state.mailbox[this.index].refresh
        );

        formData.append(
          `host`,
          this.$store.state.mailbox[this.index].type == "imap"
            ? this.$store.state.settings[
                this.$store.state.mailbox[this.index].server
              ].imap.address
            : this.$store.state.settings[
                this.$store.state.mailbox[this.index].server
              ].hostSend
        );
        formData.append(`type`, this.$store.state.mailbox[this.index].type);
        formData.append(
          `port`,
          this.$store.state.settings[
            this.$store.state.mailbox[this.index].server
          ].portSend
        );
        formData.append(`encrypt`, "ssl");
        formData.append(`from`, this.from);
        formData.append(`fromName`, this.from);
        for (const index in this.mailsTo) {
          formData.append(`adresses[${index}]`, this.mailsTo[index]);
        }

        formData.append(`subject`, this.theme);
        formData.append(`text`, this.content);
        console.log(this.files);
        for (const fileIndex in this.files) {
          let fileObj = this.files[fileIndex];
          if (this.files[fileIndex] instanceof Blob) {
            const base64 = await this.convertFileToBase64(
              this.files[fileIndex]
            );
            console.log({ base64 });
            fileObj = {
              name: this.files[fileIndex].name, // Имя файла
              base64: base64, // Данные файла в формате base64
            };
            console.log({ fileObj });
            const jsonData = JSON.stringify(fileObj);
            formData.append(`file[${fileIndex}]`, jsonData); // Выводим результат
          } else {
            const jsonData = JSON.stringify(fileObj);
            formData.append(`file[${fileIndex}]`, jsonData);
          }
        }
        //

        //получить все письма по каждой из папки
        const mail = await axios.post("https://email.rcgit.ru/smtp/", formData);
        console.log({ mail });
        this.files = [];
        this.newFiles = [];
        this.content = "";
        this.mailsTo = [];
        this.theme = "";
        this.loading = false;
        this.$emit("update:modal", false);
      } catch (error) {
        console.log({ error });
      }
    },
    openFileDialog() {
      this.$refs.fileInput.click();
    },
    // Метод для обработки выбора файла
    handleFileChange(event) {
      const selectedFiles = event.target.files;
      console.log({ selectedFiles });
      if (selectedFiles) {
        this.files.push(...Array.from(selectedFiles));

        // Преобразуем FileList в массив и сохраняем
      }
    },
    deleteFile(index) {
      this.files.splice(index, 1);
    },
    handleInput(value) {
      console.log("Введенное значение:", value);
    },
    removeChip(index, type) {
      if (type == "To") {
        this.chipsTo.splice(index, 1);
      } else {
        this.chipsFrom.splice(index, 1);
      }
    },
    pause(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    swipe() {
      this.$emit("update:modal", false);
    },
  },
  created() {
    if (!this.newMail) {
      console.log(this.item);
      this.content = this.fwd
        ? `
      <br/>
      -------- Пересылаемое сообщение --------<br/>
 ${this.item.dateTitle}, ${this.item.timeTitle}, "${this.item.fromName}" <${this.item.from}>:<br/>
Кому: ${this.item.to};<br/>
Тема: ${this.item.subject};<br/>
      ${this.item.body}`
        : `
      <br/>
      ----------------<br/>
      Кому: ${this.item.to};<br/>
      Тема: ${this.item.subject};<br/>
      ${this.item.dateTitle}, ${this.item.timeTitle}, "${this.item.fromName}" <${this.item.from}>:<br/>
      ${this.item.body}`;
      this.theme = this.fwd
        ? `Fwd: ${this.item.subject}`
        : `Re: ${this.item.subject}`;
      this.files = this.item.files;
      this.mailsTo = this.fwd ? [] : [this.item.from];
    }
    for (const box of this.$store.state.mailbox) {
      this.itemsFrom.push(box.title);
    }
    this.from = this.$store.state.mailbox[this.index].title;
  },
};
</script>
<style scoped>
.displaynone {
  display: none;
}
</style>
